<template>
  <div class="overlay">
    <div class="text-center">
      <div class="spinner-border text-light" role="status" style="width: 3rem; height: 3rem;">
        <h4 class="sr-only">Cargando...</h4>
      </div>
      <div class="mt-3 text-white font-weight-bold loading-text">Cargando...</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loading",
};
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--overlay-backdrop); /* fondo negro claro */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.loading-text {
  font-size: 1.5rem;
}
</style>